module.exports = __webpack_public_path__ + "static/img/d-14.cc5b0f38.png";